import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersistentManager } from "../../utils/PersistentManager";

export interface CanvasState {
  scale: number;
  position: {
    x: number;
    y: number;
  };
}

const CANVAS_STORAGE_KEY = 'canvas_state';

const initialState: CanvasState = {
  scale: 1,
  position: { x: 0, y: 0 }
};

const canvasSlice = createSlice({
  name: 'canvas',
  initialState,
  reducers: {
    setScale: (state, action: PayloadAction<number>) => {
      state.scale = action.payload;
      // Save state to storage
      PersistentManager.getInstance().setItem(CANVAS_STORAGE_KEY, JSON.stringify({
        scale: state.scale,
        position: state.position
      }));
    },
    setPosition: (state, action: PayloadAction<{ x: number, y: number }>) => {
      state.position = action.payload;
      // Save state to storage
      PersistentManager.getInstance().setItem(CANVAS_STORAGE_KEY, JSON.stringify({
        scale: state.scale,
        position: state.position
      }));
    },
    setCanvasState: (state, action: PayloadAction<CanvasState>) => {
      state.scale = action.payload.scale;
      state.position = action.payload.position;
      // Save state to storage
      PersistentManager.getInstance().setItem(CANVAS_STORAGE_KEY, JSON.stringify({
        scale: state.scale,
        position: state.position
      }));
    },
  },
});

export const { setScale, setPosition, setCanvasState } = canvasSlice.actions;
export default canvasSlice.reducer; 